import React from "react";
import { FaqState } from "../../utils/interfaces/faq";
import productConstant from "../../pages/products/constants.json";
import plus from "../../assets/images/plus.svg";
import minus from "../../assets/images/minus.svg";

import "./style.css";
import { CmsBlocksDataState } from "../../utils/interfaces/cmsBlock";
import { appendUtmParamsToLinks } from "../../utils/utility";
export interface FAQProps {
  data: Array<FaqState>; // Define the prop type
  contactUs: CmsBlocksDataState;
}

const FAQ = (props: FAQProps) => {
  let htmlContent = "";
  if (
    props.contactUs &&
    props.contactUs?.items &&
    props.contactUs?.items.length > 0
  )
    htmlContent = props.contactUs?.items[0]?.content;
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, "text/html");
  const extractedText = doc.body.textContent || "";
  const modifiedText = appendUtmParamsToLinks(extractedText);

  return (
    <section className="mx-auto py-6 md:py-16 bg-white px-6 md:px-8">
      <h2 className="faq-title text-2xl font-lato font-black text-center mb-10 lg:text-5xl md:mb-8">
        {productConstant.faqTitle}
      </h2>

      <div className="mx-auto w-full mt-9">
        <div className="accordian divide-y divide-grey-scale-blue-grey-100">
          {props.data.map((faq) => (
            <details
              key={faq.faq_id}
              className="group accordion-item p-6 md:p-8"
            >
              <summary className="flex cursor-pointer list-none items-center justify-between text-lg font-lato font-bold text-secondary-900 group-open:text-primary-500 md:text-xl md:font-bold">
                {faq.question}
                <div className="accordian-icons">
                  <img
                    src={plus}
                    alt="Plus"
                    className="icons block h-5 w-5 group-open:hidden"
                    data-track={`plus-icon-${faq.faq_id}`}
                  />
                  <img
                    src={minus}
                    alt="Minus"
                    className="icons hidden h-5 w-5 group-open:block"
                    data-track={`minus-icon-${faq.faq_id}`}
                  />
                </div>
              </summary>
              <span
                className="accordian-answer pb-4 text-secondary-500 font-lato "
                dangerouslySetInnerHTML={{ __html: faq.answer }}
              ></span>
            </details>
          ))}
        </div>
      </div>

      <div className="container mx-auto text-center my-6 md:my-12">
        <div
          className="text-sm md:text-xl"
          dangerouslySetInnerHTML={{ __html: modifiedText }}
        ></div>
      </div>
    </section>
  );
};

export default FAQ;
